import Vue from 'vue';
import VueTranslate from 'vue-translate-plugin';

Vue.use(VueTranslate);

Vue.lang('es')

Vue.locales({
	es: {
		'verified': 'Verificado',
		'reviewNeeded': 'Revisión manual necesaria',
		'rejected': 'Rechazado',
		
		'address': 'Dirección',
		'cde': 'Clave de Elector',
		'fullName': 'Nombre completo',
		'emissionDate': 'Fecha de emisión',
		'documentNumber': 'Número de documento',
		'dateOfBirth': 'Fecha de nacimiento',
		'expirationDate': 'Fecha de expiración',
		'documentType': 'Tipo de documento',
		'firstName': 'Primer nombre',
		'issueCountry': 'País de emisión',
		'nationality': 'Nacionalidad',
		'optional2': 'Opcional 2',
		'sex': 'Género',
		'surname': 'Apellido(s)',
		'curp': 'CURP',
		'ne': 'Número de emisión',
		'ocrNumber': 'Número de OCR',

		'national-id': 'Identificación Nacional',
		'passport': 'Pasaporte',
		'driving-license': 'Licencia de Conducir',
		'proof-of-residency': 'Comprobante de Domicilio',
		'MX': 'México',

		'mexican-curp-validation': 'CURP mexicano',
		'alteration-detection': 'Detección de alteracíon de documentos',
		'template-matching': 'Revisíon de tipo de documento',
		'facematch': 'Facematch con selfie',
		'age-check': 'Comprobación de edad',
		'document-reading': 'Lectura de documento',
		'watchlists': 'Detección de listas de observación',

		'H': 'Hombre',
		'M': 'Mujer',

		'PF': 'Persona Física',
		'PM': 'Persona Moral',
		'PFAE': 'Persona Física con Activiad Empresarial',

		// Promotor Status
		'pendiente': 'Pendiente',
		'manual': 'Revisión Manual',
		'activo': 'Activo',
		'desactivado': 'Desactivado',

		// Lead Digital Status
		'en espera': 'En espera',
		'procede': 'Procede',
		'completado': 'Completado',
		'cancelado': 'Cancelado',
		'rollback': 'rollback',

		// Cobranzas Status
		'creada': 'Creada',
		'aceptada': 'Aceptada',
		'en proceso': 'En proceso',
		'concluida': 'Concluida',
		'cerrada': 'Cerrada',
	}
})